import { Component } from 'react';
import { ConvertOptionsComponentV2 } from '../../convert-options-v2/convert-options.component';
import { ConvertOptionsContextV2, ConvertOptionsSummary } from '../../convert-options-v2/convert-options.context';
import { UploadInProgressFile } from '../../../models/upload-in-progress-file';
import Checkbox from '../checkbox/checkbox.component';
import ContactUsModal from '../contact-us-modal/contact-us.modal';
import styles from './advanced-options-section.component.module.scss';

export interface AdvancedOptionsSectionProps {
    convertOptionsContext: ConvertOptionsContextV2;
    uploadInProgressFiles: UploadInProgressFile<any>[];
    onOptionChange: (data: ConvertOptionsSummary) => void;
    path: string;
}

interface AdvancedOptionsSectionState {
    showAdvanced: boolean;
}

export class AdvancedOptionsSectionComponent extends Component<AdvancedOptionsSectionProps, AdvancedOptionsSectionState> {
    readonly state: Readonly<AdvancedOptionsSectionState> = {
        showAdvanced: false,
    };

    render() {
        const { convertOptionsContext, uploadInProgressFiles, onOptionChange, path } = this.props;
        return (
            <div className={styles['container']}>
                <div className={styles['header']}>
                    <div className={styles['notice']}>
                        <div className="d-flex align-items-center">
                            <img className={styles['icon']} src="/icons/svg/gear.svg" alt="Options" />
                            <span>
                                <b>Advanced Options</b> - Our defaults are optimized for the best results. <span className="text-danger fw-bold">We recommend you keeping the defaults unless you have a specific need.</span>
                            </span>
                        </div>
                        {
                            convertOptionsContext.getModel().hasAdvancedOptions() &&
                            <div className={styles['toggle']} onClick={() => this.setState({ showAdvanced: !this.state.showAdvanced })}>
                                <span className="user-select-none">Show All Options</span>
                                <Checkbox
                                    initialValue={this.state.showAdvanced}
                                    onChange={(v) => this.setState({ showAdvanced: v })}
                                    emitInitialValueOnInit={true}
                                    ariaLabel="Show Advanced Options toggle"
                                />
                            </div>
                        }
                        <div className={styles['header-actions']}>
                            <a className={styles['action-link']} href="#" onClick={(e) => { e.preventDefault(); convertOptionsContext.resetToDefaults(); }}>
                                <img src="/icons/svg/arrow-counterclockwise.svg" alt="" /> Reset to defaults
                            </a>
                            <a className={styles['action-link']} href="#" onClick={(e) => { e.preventDefault(); ContactUsModal.show({}); }}>
                                <img src="/icons/svg/question.svg" alt="" /> Need help?
                            </a>
                        </div>
                    </div>
                </div>
                <div className={styles['body']}>
                    <ConvertOptionsComponentV2
                        convertOptionsContext={convertOptionsContext}
                        uploadInProgressFiles={uploadInProgressFiles}
                        onOptionChange={onOptionChange}
                        showAdvanced={this.state.showAdvanced}
                        path={path}
                    />
                </div>
            </div>
        );
    }
}
